/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './acceptConvo.defs.js'
export { main as default } from './acceptConvo.defs.js'
